export const ENABLE = 'V-DANMU-DANMU_EVENT-ENABLE'
export const DISABLE = 'V-DANMU-DANMU_EVENT-DISABLE'
export const SIGNIN = 'V-DANMU-DANMU_EVENT-SIGNIN'
export const SIGNUP = 'V-DANMU-DANMU_EVENT-SIGNUP'
export const SUBMIT = 'V-DANMU-DANMU_EVENT-SUBMIT'

export const POSITION = 'V-DANMU-DANMU_EVENT-POSITION'
export const SIZE = 'V-DANMU-DANMU_EVENT-SIZE'
export const TYPE = 'V-DANMU-DANMU_EVENT-TYPE'
export const TYPE_CHANGE = 'V-DANMU-DANMU_EVENT-TYPE_CHANGE'
export const OPACITY = 'V-DANMU-DANMU_EVENT-OPACITY'
export const OPACITY_END = 'V-DANMU-DANMU_EVENT-OPACITY_END'

export default {
  ENABLE, DISABLE, SIGNIN, SIGNUP, SUBMIT, POSITION, SIZE, TYPE, OPACITY, OPACITY_END
}
